import { render } from "./Header.vue?vue&type=template&id=83672192&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=83672192&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-83672192"

export default script